import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import List from "../Components/Target/List";
import Add from "../Components/Target/Add";

import { useLocation } from "react-router-dom";

function Target(row) {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState(row.rowData);
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const lastWord = pathParts[pathParts.length - 1];
  const [heading, setHeading] = useState("");

  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  useEffect(() => {
    let vendorType = "";
    if (lastWord === "distributor") vendorType = "Distributor";
    else if (lastWord === "dealer") vendorType = "Dealer";
    else if (lastWord === "retailer") vendorType = "Retailer";
    else if (lastWord === "key-accounts") vendorType = "Key Accounts";
    else if (lastWord === "pro") vendorType = "PRO";

    setHeading(vendorType);
  }, [lastWord]);

  return (
    // <div className="main-content">
    // <section className="section">
    //   <div className="section-header">
    //     <h1>{"Target"}</h1>
    //   </div>
    <>
      {comp === "list" ? (
        <List
          comp={comp}
          onChange={handleChange}
          rowData={rowData}
          currentComp={lastWord}
          id={row?.rowData?.id}
          row={row}

        />
      ) : (
        <Add
          comp={comp}
          rowData={rowData}
          onChange={handleChange}
          currentComp={lastWord}
          id={row?.rowData?.id}
        />
      )}
    </>
    //{" "}
    //  </section>
    // </div>
  );
}

export default Target;
